import axiosClient from "../../../helpers/axios-client";
import { CLOSE_FORM_LOADING, FORM_SUBMISSION_STATUS } from "../../common/actionTypes";
import { CREATE_ITEM_CATEGORY_URL, GET_ALL_MARKET_CATEGORIES_URL, CREATE_MARKET_CATEGORY_URL, UPDATE_MARKET_CATEGORY_URL, TOGGLE_MARKET_CATEGORY_URL, DELETE_MARKET_CATEGORY_URL, CREATE_ITEM_GROUP_URL, CREATE_ITEM_URL, DELETE_ITEM_CATEGORY_URL, DELETE_ITEM_GROUP_URL, DELETE_ITEM_URL, GET_ALL_ITEMS_URL, GET_ALL_ITEM_CATEGORIES_URL, GET_ALL_ITEM_GROUPS_URL, GET_ITEM_SCHEDULE_DATA_URL, GET_SINGLE_ITEM_URL, LINK_ITEM_GROUP_STORE_URL, TOGGLE_ITEM_CATEGORY_URL, TOGGLE_ITEM_GROUP_URL, TOGGLE_ITEM_URL, UPDATE_ITEM_CATEGORY_URL, UPDATE_ITEM_GROUP_URL, UPDATE_ITEM_SCHEDULE_DATA_URL, UPDATE_ITEM_URL, UPDATE_ITEM_ADDON_URL, ADD_ITEM_ADDON_URL, DELETE_ITEM_ADDON_URL, CHANGE_ADDON_CATEGORY_TYPE_URL } from "../../../config";
import { GET_ALL_ITEMS, GET_ALL_MARKET_CATEGORIES, GET_ALL_ITEM_CATEGORIES, UPDATE_ITEM_ADDON, GET_ALL_ITEM_GROUPS, GET_ITEM_SCHEDULE_DATA, GET_SINGLE_ITEM, ADD_ITEM_ADDON, DELETE_ITEM_ADDON } from './actionType';


//Market category
export const getAllMarketCategories = () => (dispatch) => {
    return axiosClient.post(GET_ALL_MARKET_CATEGORIES_URL).then((response) => {
        if (response && response.data.success) {
            const categories = response.data.data;
            return dispatch({ type: GET_ALL_MARKET_CATEGORIES, payload: categories });
        }
    }).catch(function (error) {
        console.log(error);
    });
};

export const createMarketCategory = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(CREATE_MARKET_CATEGORY_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const updateMarketCategory = (data, id) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }

    return axiosClient
        .post(UPDATE_MARKET_CATEGORY_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const toggleMarketCategory = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_MARKET_CATEGORY_URL, {
        id,
    });
};

export const deleteMarketCategory = (id) => (dispatch) => {
    return axiosClient.post(DELETE_MARKET_CATEGORY_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};


//item category
export const getAllItemCategories = () => (dispatch) => {
    return axiosClient
        .post(GET_ALL_ITEM_CATEGORIES_URL)
        .then((response) => {
            if (response && response.data.success) {
                const categories = response.data.data;
                return dispatch({ type: GET_ALL_ITEM_CATEGORIES, payload: categories });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const createItemCategory = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(CREATE_ITEM_CATEGORY_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const updateItemCategory = (data, id) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }

    return axiosClient
        .post(UPDATE_ITEM_CATEGORY_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const toggleCategory = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_ITEM_CATEGORY_URL, {
        id,
    });
};

export const deleteCategory = (id) => (dispatch) => {
    return axiosClient.post(DELETE_ITEM_CATEGORY_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};

//item
export const getAllItems = () => (dispatch) => {
    return axiosClient
        .post(GET_ALL_ITEMS_URL)
        .then((response) => {
            if (response && response.data.success) {
                const items = response.data;
                return dispatch({ type: GET_ALL_ITEMS, payload: items });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const getItemScheduleData = (id) => (dispatch) => {
    return axiosClient
        .post(GET_ITEM_SCHEDULE_DATA_URL, { id })
        .then((response) => {
            if (response && response.data.success) {
                const data = response.data.data;
                return dispatch({ type: GET_ITEM_SCHEDULE_DATA, payload: data });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}
export const updateItemScheduleData = (id, schedule_data) => (dispatch) => {
    return axiosClient
        .post(UPDATE_ITEM_SCHEDULE_DATA_URL, { id, schedule_data })
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const getSingleItem = (id) => (dispatch) => {
    return axiosClient
        .post(GET_SINGLE_ITEM_URL, { id })
        .then((response) => {
            if (response && response.data.success) {
                const item = response.data.data;
                return dispatch({ type: GET_SINGLE_ITEM, payload: item });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const createItem = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(CREATE_ITEM_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const updateItem = (data) => (dispatch) => {
    console.log(data, 'actionnnn')
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(UPDATE_ITEM_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const toggleItem = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_ITEM_URL, {
        id,
    });
};

export const changeAddonCategoryType = (category_id, type) => (dispatch) => {
    return axiosClient.post(CHANGE_ADDON_CATEGORY_TYPE_URL, {
        category_id, type,
    });
};
export const deleteItem = (id) => (dispatch) => {
    return axiosClient.post(DELETE_ITEM_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};

export const addNewAddonCategory = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(ADD_ITEM_ADDON_URL, data, config)
        .then((response) => {
            if (response && response.data.success) {
                const item = response.data;
                dispatch({
                    type: CLOSE_FORM_LOADING,
                });
                dispatch({
                    type: FORM_SUBMISSION_STATUS,
                    payload: true,
                });
                return dispatch({ type: ADD_ITEM_ADDON, payload: item });
            }
        });
};

export const updateItemAddon = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(UPDATE_ITEM_ADDON_URL, data, config)
        .then((response) => {
            if (response && response.data.success) {
                const item = response.data;
                dispatch({
                    type: CLOSE_FORM_LOADING,
                });
                dispatch({
                    type: FORM_SUBMISSION_STATUS,
                    payload: true,
                });
                return dispatch({ type: UPDATE_ITEM_ADDON, payload: item });
            }
        });
};

export const deleteItemAddon = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(DELETE_ITEM_ADDON_URL, data, config)
        .then((response) => {
            if (response && response.data.success) {
                const item = response.data;
                dispatch({
                    type: CLOSE_FORM_LOADING,
                });
                dispatch({
                    type: FORM_SUBMISSION_STATUS,
                    payload: true,
                });
                return dispatch({ type: DELETE_ITEM_ADDON, payload: item });
            }
        });
};


//item group
//item category
export const getAllItemGroups = () => (dispatch) => {
    return axiosClient
        .post(GET_ALL_ITEM_GROUPS_URL)
        .then((response) => {
            if (response && response.data.success) {
                const groups = response.data.data;
                return dispatch({ type: GET_ALL_ITEM_GROUPS, payload: groups });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const createItemGroup = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(CREATE_ITEM_GROUP_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const updateItemGroup = (data, id) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }

    return axiosClient
        .post(UPDATE_ITEM_GROUP_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });
            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};

export const toggleGroup = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_ITEM_GROUP_URL, {
        id,
    });
};

export const linkItemGroupStore = (data) => (dispatch) => {
    return axiosClient.post(LINK_ITEM_GROUP_STORE_URL, data).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};

export const deleteGroup = (id) => (dispatch) => {
    return axiosClient.post(DELETE_ITEM_GROUP_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};
